/* eslint-disable jsx-a11y/anchor-is-valid */
import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#08206B] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 text-center md:text-left">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Kazi Agency</h3>
            <p className="text-gray-300">
              Lorem Ipsum is simply lorem dummy text of the printing and typesetting industry.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-medium mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-center justify-center md:justify-start space-x-3">
                <PhoneIcon className="w-5 h-5 text-white" />
                <span className="text-gray-300">+44 1234567890</span>
              </div>
              <div className="flex items-center justify-center md:justify-start space-x-3">
                <EnvelopeIcon className="w-5 h-5 text-white" />
                <span className="text-gray-300">kaziagency.co.uk@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Policy */}
          <div>
            <h4 className="text-xl font-medium mb-4">Policy</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="text-gray-300 hover:text-white transition-colors">
                  Terms & Condition
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h4 className="text-xl font-medium mb-4">Follow Us</h4>
            <div className="flex justify-center md:justify-start space-x-4">
              <a href="#" className="w-8 h-8 bg-white rounded-full flex items-center justify-center hover:bg-gray-200">
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_118_119)">
                    <path d="M5.22407 6.8335H1.09375V20.1656H5.22407V6.8335Z" fill="#08206B" />
                    <path d="M3.13875 5.08544C4.48898 5.08544 5.58219 3.98197 5.58219 2.62524C5.58219 1.26851 4.48536 0.165039 3.13875 0.165039C1.78853 0.165039 0.695312 1.26489 0.695312 2.62524C0.695312 3.98559 1.78853 5.08544 3.13875 5.08544Z" fill="#08206B" />
                    <path d="M11.8235 13.1643C11.8235 11.2903 12.685 10.1723 14.3393 10.1723C15.856 10.1723 16.5873 11.2432 16.5873 13.1643C16.5873 15.0855 16.5873 20.1651 16.5873 20.1651H20.6959C20.6959 20.1651 20.6959 15.2953 20.6959 11.7244C20.6959 8.15349 18.6687 6.42773 15.8416 6.42773C13.0108 6.42773 11.8198 8.63106 11.8198 8.63106V6.83656H7.86328V20.1687H11.8235C11.8235 20.1651 11.8235 15.2193 11.8235 13.1643Z" fill="#08206B" />
                  </g>
                  <defs>
                    <clipPath id="clip0_118_119">
                      <rect width="20" height="20" fill="white" transform="translate(0.695312 0.165039)" />
                    </clipPath>
                  </defs>
                </svg>

              </a>
              <a href="#" className="w-8 h-8 bg-white rounded-full flex items-center justify-center hover:bg-gray-200">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.0592 0.907715C18.1542 0.909985 18.2494 0.941251 18.3278 1.00635C18.5074 1.1547 18.5345 1.423 18.3854 1.60303L11.5573 9.90479L17.8053 18.7563C17.9394 18.9476 17.8938 19.2125 17.7028 19.3472C17.6289 19.3988 17.5433 19.4243 17.4596 19.4243L14.2077 19.4253C14.0555 19.4253 13.9217 19.344 13.8463 19.2241L9.25063 12.7124L3.87954 19.2417C3.80325 19.3516 3.67516 19.4251 3.53091 19.4253H1.13833C1.04353 19.4231 0.94718 19.3924 0.868796 19.3276C0.688831 19.1797 0.662747 18.9112 0.811179 18.731L7.6393 10.4302L1.39126 1.57764C1.25651 1.38655 1.30313 1.12192 1.4938 0.986816C1.56791 0.93483 1.65387 0.909668 1.73794 0.909668H4.98891C5.1415 0.909719 5.27603 0.990312 5.35122 1.11084L9.94692 7.62158L15.317 1.09131C15.3934 0.980863 15.5219 0.907715 15.6666 0.907715H18.0592Z" fill="#08206B" />
                </svg>
              </a>
            </div>
          </div>
        </div>


        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-4 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            Copyright © 2025 Kazi Agency. All Rights Reserved.
          </p>
          <p className="text-gray-400 text-sm mt-2 md:mt-0">
            Website By: <a href="https://sdssoftwares.co.uk" className="hover:underline">sdssoftwares.co.uk</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
